// @ts-strict-ignore
import { createReducer, on } from "@ngrx/store";
import { APIModel } from "../shared/services/api.service";
import { APIActions } from "./api.actions.types";

export interface APIState {
  esimProfiles: APIModel.ESimProfileDto[];
  jobTemplates: APIModel.JobTemplateDto[];
  jobs: APIModel.JobDto[];
  javaApplets: APIModel.JavaAppletDto[];
  homeNetworkPublicKeys: APIModel.HomeNetworkPublicKeyDto[];
  milenageParameters: APIModel.MilenageParamDto[];
  smdpDestinations: APIModel.SmdpDetailsDto[];
  outputFiles: APIModel.OutputFileDestinationDetails[];
  tuakKeys: APIModel.TuakParameterSetDetailsDto[];
}

export const defaultState: APIState = {
  esimProfiles: undefined,
  jobTemplates: undefined,
  jobs: undefined,
  javaApplets: undefined,
  homeNetworkPublicKeys: undefined,
  milenageParameters: undefined,
  smdpDestinations: undefined,
  outputFiles: undefined,
  tuakKeys: undefined
};

export const APIReducer = createReducer(
  defaultState,

  /******************************************************************************
    ESimProfileDto
  ******************************************************************************/

  on(APIActions.CreateESimProfile, (state, action) => {
    return { ...state, esimProfiles: [...(state.esimProfiles ?? []), action.profile] };
  }),
  on(APIActions.CreateESimProfiles, (state, action) => {
    return {
      ...state,
      esimProfiles: [...(state.esimProfiles ?? []), ...action.profiles]
    };
  }),
  on(APIActions.UpdateESimProfile, (state, action) => {
    return {
      ...state,
      esimProfiles: [...(state.esimProfiles?.filter((record) => record.id !== action.profile.id) ?? []), action.profile]
    };
  }),
  on(APIActions.UpdateESimProfiles, (state, action) => {
    return {
      ...state,
      esimProfiles: [
        ...state.esimProfiles.filter((record) => !action.profiles.map((updatedRecord) => updatedRecord.id).includes(record.id)),
        ...action.profiles
      ]
    };
  }),
  on(APIActions.DeleteESimProfile, (state, action) => {
    return {
      ...state,
      esimProfiles: [...state.esimProfiles.filter((record) => record.id !== action.id)]
    };
  }),
  on(APIActions.DeleteESimProfiles, (state, action) => {
    return {
      ...state,
      esimProfiles: [...state.esimProfiles.filter((record) => !action.ids.includes(record.id))]
    };
  }),
  on(APIActions.ClearESimProfiles, (state) => {
    return {
      ...state,
      esimProfiles: undefined
    };
  }),

  /******************************************************************************
    JobTemplateDto
  ******************************************************************************/

  on(APIActions.CreateJobTemplate, (state, action) => {
    return { ...state, jobTemplates: [...(state.jobTemplates ?? []), action.jobTemplate] };
  }),
  on(APIActions.CreateJobTemplates, (state, action) => {
    return {
      ...state,
      jobTemplates: [...(state.jobTemplates ?? []), ...action.jobTemplates]
    };
  }),
  on(APIActions.UpdateJobTemplate, (state, action) => {
    return {
      ...state,
      jobTemplates: [...state.jobTemplates.filter((record) => record.id !== action.jobTemplate.id), action.jobTemplate]
    };
  }),
  on(APIActions.UpdateJobTemplates, (state, action) => {
    return {
      ...state,
      jobTemplates: [
        ...state.jobTemplates.filter((record) => !action.jobTemplates.map((updatedRecord) => updatedRecord.id).includes(record.id)),
        ...action.jobTemplates
      ]
    };
  }),
  on(APIActions.DeleteJobTemplate, (state, action) => {
    return {
      ...state,
      jobTemplates: [...state.jobTemplates.filter((record) => record.id !== action.id)]
    };
  }),
  on(APIActions.DeleteJobTemplates, (state, action) => {
    return {
      ...state,
      jobTemplates: [...state.jobTemplates.filter((record) => !action.ids.includes(record.id))]
    };
  }),
  on(APIActions.ClearJobTemplates, (state) => {
    return {
      ...state,
      jobTemplates: undefined
    };
  }),

  /******************************************************************************
    JobDto
  ******************************************************************************/

  on(APIActions.CreateJob, (state, action) => {
    return { ...state, jobs: [...(state.jobs ?? []), action.job] };
  }),
  on(APIActions.CreateJobs, (state, action) => {
    return {
      ...state,
      jobs: [...(state.jobs ?? []), ...action.jobs]
    };
  }),
  on(APIActions.UpdateJob, (state, action) => {
    return {
      ...state,
      jobs: [...state.jobs.filter((record) => record.id !== action.job.id), action.job]
    };
  }),
  on(APIActions.UpdateJobs, (state, action) => {
    return {
      ...state,
      jobs: [
        ...(state.jobs || []).filter((record) => !action.jobs.map((updatedRecord) => updatedRecord.id).includes(record.id)),
        ...action.jobs
      ]
    };
  }),
  on(APIActions.DeleteJob, (state, action) => {
    return {
      ...state,
      jobs: [...state.jobs.filter((record) => record.id !== action.id)]
    };
  }),
  on(APIActions.DeleteJobs, (state, action) => {
    return {
      ...state,
      jobs: [...state.jobs.filter((record) => !action.ids.includes(record.id))]
    };
  }),
  on(APIActions.ClearJobs, (state) => {
    return {
      ...state,
      jobs: undefined
    };
  }),

  /******************************************************************************
    JavaAppletDto
  ******************************************************************************/

  on(APIActions.CreateJavaApplet, (state, action) => {
    return { ...state, javaApplets: [...(state.javaApplets ?? []), action.applet] };
  }),
  on(APIActions.CreateJavaApplets, (state, action) => {
    return { ...state, javaApplets: [...(state.javaApplets ?? []), ...action.applets] };
  }),
  on(APIActions.UpdateJavaApplet, (state, action) => {
    return {
      ...state,
      javaApplets: [...state.javaApplets.filter((record) => record.id !== action.applet.id), action.applet]
    };
  }),
  on(APIActions.UpdateJavaApplets, (state, action) => {
    return {
      ...state,
      javaApplets: [
        ...state.javaApplets.filter((record) => !action.applets.map((updatedRecord) => updatedRecord.id).includes(record.id)),
        ...action.applets
      ]
    };
  }),
  on(APIActions.DeleteJavaApplet, (state, action) => {
    return {
      ...state,
      javaApplets: [...state.javaApplets.filter((record) => record.id !== action.id)]
    };
  }),
  on(APIActions.DeleteJavaApplets, (state, action) => {
    return {
      ...state,
      javaApplets: [...state.javaApplets.filter((record) => !action.ids.includes(record.id))]
    };
  }),
  on(APIActions.ClearJavaApplets, (state) => {
    return {
      ...state,
      javaApplets: undefined
    };
  }),

  /******************************************************************************
    HomeNetworkPublicKeyDto
  ******************************************************************************/

  on(APIActions.CreateHomeNetworkPublicKey, (state, action) => {
    return { ...state, homeNetworkPublicKeys: [...(state.homeNetworkPublicKeys ?? []), action.key] };
  }),
  on(APIActions.CreateHomeNetworkPublicKeys, (state, action) => {
    return { ...state, homeNetworkPublicKeys: [...(state.homeNetworkPublicKeys ?? []), ...action.keys] };
  }),
  on(APIActions.UpdateHomeNetworkPublicKey, (state, action) => {
    return {
      ...state,
      homeNetworkPublicKeys: [...state.homeNetworkPublicKeys.filter((record) => record.id !== action.key.id), action.key]
    };
  }),
  on(APIActions.UpdateHomeNetworkPublicKeys, (state, action) => {
    return {
      ...state,
      homeNetworkPublicKeys: [
        ...state.homeNetworkPublicKeys.filter((record) => !action.keys.map((updatedRecord) => updatedRecord.id).includes(record.id)),
        ...action.keys
      ]
    };
  }),
  on(APIActions.DeleteHomeNetworkPublicKey, (state, action) => {
    return {
      ...state,
      homeNetworkPublicKeys: [...state.homeNetworkPublicKeys.filter((record) => record.id !== action.id)]
    };
  }),
  on(APIActions.DeleteHomeNetworkPublicKeys, (state, action) => {
    return {
      ...state,
      homeNetworkPublicKeys: [...state.homeNetworkPublicKeys.filter((record) => !action.ids.includes(record.id))]
    };
  }),
  on(APIActions.ClearHomeNetworkPublicKeys, (state) => {
    return {
      ...state,
      homeNetworkPublicKeys: undefined
    };
  }),

  /******************************************************************************
    MilenageParamDto
  ******************************************************************************/

  on(APIActions.CreateMilenageParam, (state, action) => {
    return { ...state, milenageParameters: [...(state.milenageParameters ?? []), action.milenageParam] };
  }),
  on(APIActions.CreateMilenageParams, (state, action) => {
    return {
      ...state,
      milenageParameters: [...(state.milenageParameters ?? []), ...action.milenageParams]
    };
  }),
  on(APIActions.UpdateMilenageParam, (state, action) => {
    return {
      ...state,
      milenageParameters: [...state.milenageParameters.filter((record) => record.id !== action.milenageParam.id), action.milenageParam]
    };
  }),
  on(APIActions.UpdateMilenageParams, (state, action) => {
    return {
      ...state,
      milenageParameters: [
        ...state.milenageParameters.filter((record) => !action.milenageParams.map((updatedRecord) => updatedRecord.id).includes(record.id)),
        ...action.milenageParams
      ]
    };
  }),
  on(APIActions.DeleteMilenageParam, (state, action) => {
    return {
      ...state,
      milenageParameters: [...state.milenageParameters.filter((record) => record.id !== action.id)]
    };
  }),
  on(APIActions.DeleteMilenageParams, (state, action) => {
    return {
      ...state,
      milenageParameters: [...state.milenageParameters.filter((record) => !action.ids.includes(record.id))]
    };
  }),
  on(APIActions.ClearMilenageParams, (state) => {
    return {
      ...state,
      milenageParameters: undefined
    };
  }),

  /******************************************************************************
    SmdpDetailsDto
  ******************************************************************************/

  on(APIActions.CreateSMDPDestination, (state, action) => {
    return { ...state, smdpDestinations: [...(state.smdpDestinations ?? []), action.destination] };
  }),
  on(APIActions.CreateSMDPDestinations, (state, action) => {
    return { ...state, smdpDestinations: [...(state.smdpDestinations ?? []), ...action.destinations] };
  }),
  on(APIActions.UpdateSMDPDestination, (state, action) => {
    return {
      ...state,
      smdpDestinations: [...state.smdpDestinations.filter((record) => record.id !== action.destination.id), action.destination]
    };
  }),
  on(APIActions.UpdateSMDPDestinations, (state, action) => {
    return {
      ...state,
      smdpDestinations: [
        ...state.smdpDestinations.filter((record) => !action.destinations.map((updatedRecord) => updatedRecord.id).includes(record.id)),
        ...action.destinations
      ]
    };
  }),
  on(APIActions.DeleteSMDPDestination, (state, action) => {
    return {
      ...state,
      smdpDestinations: [...state.smdpDestinations.filter((record) => record.id !== action.id)]
    };
  }),
  on(APIActions.DeleteSMDPDestinations, (state, action) => {
    return {
      ...state,
      smdpDestinations: [...state.smdpDestinations.filter((record) => !action.ids.includes(record.id))]
    };
  }),
  on(APIActions.ClearSMDPDestinations, (state) => {
    return {
      ...state,
      smdpDestinations: undefined
    };
  }),

  /******************************************************************************
    OutputFileDestination
  ******************************************************************************/

  on(APIActions.CreateOutputFile, (state, action) => {
    return { ...state, outputFiles: [...(state.outputFiles ?? []), action.file] };
  }),
  on(APIActions.CreateOutputFiles, (state, action) => {
    return { ...state, outputFiles: [...(state.outputFiles ?? []), ...action.files] };
  }),
  on(APIActions.UpdateOutputFile, (state, action) => {
    return {
      ...state,
      outputFiles: [...state.outputFiles.filter((record) => record.id !== action.file.id), action.file]
    };
  }),
  on(APIActions.UpdateOutputFiles, (state, action) => {
    return {
      ...state,
      outputFiles: [
        ...state.outputFiles.filter((record) => !action.files.map((updatedRecord) => updatedRecord.id).includes(record.id)),
        ...action.files
      ]
    };
  }),
  on(APIActions.DeleteOutputFile, (state, action) => {
    return {
      ...state,
      outputFiles: [...state.outputFiles.filter((record) => record.id !== action.id)]
    };
  }),
  on(APIActions.DeleteOutputFiles, (state, action) => {
    return {
      ...state,
      outputFiles: [...state.outputFiles.filter((record) => !action.ids.includes(record.id))]
    };
  }),
  on(APIActions.ClearOutputFiles, (state) => {
    return {
      ...state,
      outputFiles: undefined
    };
  }),

  /******************************************************************************
    TuakKeys
  ******************************************************************************/

  on(APIActions.CreateTuakKey, (state, action) => {
    return { ...state, tuakKeys: [...(state.tuakKeys ?? []), action.key] };
  }),
  on(APIActions.CreateTuakKeys, (state, action) => {
    return {
      ...state,
      tuakKeys: [...(state.tuakKeys ?? []), ...action.keys]
    };
  }),
  on(APIActions.UpdateTuakKey, (state, action) => {
    return {
      ...state,
      tuakKeys: [...state.tuakKeys.filter((record) => record.id !== action.key.id), action.key]
    };
  }),
  on(APIActions.UpdateTuakKeys, (state, action) => {
    return {
      ...state,
      tuakKeys: [
        ...state.tuakKeys.filter((record) => !action.keys.map((updatedRecord) => updatedRecord.id).includes(record.id)),
        ...action.keys
      ]
    };
  }),
  on(APIActions.DeleteTuakKey, (state, action) => {
    return {
      ...state,
      tuakKeys: [...state.tuakKeys.filter((record) => record.id !== action.id)]
    };
  }),
  on(APIActions.DeleteTuakKeys, (state, action) => {
    return {
      ...state,
      tuakKeys: [...state.tuakKeys.filter((record) => !action.ids.includes(record.id))]
    };
  }),
  on(APIActions.ClearTuakKeys, (state) => {
    return {
      ...state,
      tuakKeys: undefined
    };
  })
);
